import React, { useState } from 'react'
import { DateTime } from 'luxon'

import {
  QueryPropsState,
  SaleSummaryProps,
} from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/interface'
import { API_URL } from '@configs/config'
import { useAuthentication } from '@hooks/useAuthentication'
import { useAlert } from '@hooks/useAlert'

const withSaleSummary = (Component: React.FC<SaleSummaryProps>) => {
  function WithSaleSummary() {
    const { token } = useAuthentication()
    const alert = useAlert()

    const [monthSelected, setMonthSelected] = useState<string>(
      String(DateTime.now().month).padStart(2, '0')
    )
    const [yearSelected, setYearSelected] = useState<number>(
      DateTime.now().year
    )
    const [queryProps, setQueryProps] = useState<QueryPropsState>({
      month: monthSelected,
      year: yearSelected,
    })
    const [isLoading, setIsLoading] = useState(false)

    const dateSelected = {
      endDate: DateTime.fromFormat(
        `${queryProps.year}-${queryProps.month}`,
        'yyyy-MM'
      )
        .endOf('month')
        .toJSDate(),
      startDate: DateTime.fromFormat(
        `${queryProps.year}-${queryProps.month}`,
        'yyyy-MM'
      )
        .startOf('month')
        .toJSDate(),
    }

    const handleQuery = () => {
      setQueryProps({
        month: String(monthSelected).padStart(2, '0'),
        year: yearSelected,
      })
    }

    async function exportFile() {
      setIsLoading(true)
      const apiUrl = API_URL.replace('/graphql', '')
      const url = `${apiUrl}/export-data-client/writer-page-by-id?startDate=${DateTime.fromJSDate(
        dateSelected.startDate
      ).toUTC()}&endDate=${DateTime.fromJSDate(dateSelected.endDate).toUTC()}`

      const response = await fetch(url, {
        method: 'GET',
        headers: { Authorization: `Bearer ${token}` },
      })

      if (response.status === 200) {
        const blob = await response.blob()
        const fileUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = fileUrl
        a.download = `writer_by_id_${monthSelected}_${yearSelected}.xlsx`
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(fileUrl)
      } else {
        alert.error('เกิดข้อผิดพลาดไม่สามารถดาวน์โหลดเอกสารได้')
      }
      setIsLoading(false)
    }

    const newProps = {
      monthSelected,
      yearSelected,
      setMonthSelected,
      setYearSelected,
      handleQuery,
      dateSelected,
      exportFile,
      isLoading,
    }
    return <Component {...newProps} />
  }
  return WithSaleSummary
}

export default withSaleSummary
